module.exports = __webpack_public_path__ + "static/img/repeat_customer.f2fa5b39.png";